var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArtboard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3917 2.1C17.3917 2.70751 17.8842 3.2 18.4917 3.2C19.0992 3.2 19.5917 2.70751 19.5917 2.1C19.5917 1.49249 19.0992 1 18.4917 1C17.8842 1 17.3917 1.49249 17.3917 2.1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3917 2.1C13.3917 2.70751 13.8842 3.2 14.4917 3.2C15.0992 3.2 15.5917 2.70751 15.5917 2.1C15.5917 1.49249 15.0992 1 14.4917 1C13.8842 1 13.3917 1.49249 13.3917 2.1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4917 3.2C9.88417 3.2 9.39169 2.70751 9.39169 2.1C9.39169 1.49249 9.88417 1 10.4917 1C11.0992 1 11.5917 1.49249 11.5917 2.1C11.5917 2.70751 11.0992 3.2 10.4917 3.2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39169 2.1C5.39169 2.70751 5.88417 3.2 6.49169 3.2C7.0992 3.2 7.59169 2.70751 7.59169 2.1C7.59169 1.49249 7.0992 1 6.49169 1C5.88417 1 5.39169 1.49249 5.39169 2.1Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3917 5C19.3917 4.44772 18.944 4 18.3917 4H6.39169C5.8394 4 5.39169 4.44772 5.39169 5V19C5.39169 19.5523 5.8394 20 6.39169 20H18.3917C18.944 20 19.3917 19.5523 19.3917 19V5ZM7.39169 6H17.3917V18H7.39169V6Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.687 5.9C22.687 6.50751 22.1945 7 21.587 7C20.9795 7 20.487 6.50751 20.487 5.9C20.487 5.29249 20.9795 4.8 21.587 4.8C22.1945 4.8 22.687 5.29249 22.687 5.9Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.687 9.9C22.687 10.5075 22.1945 11 21.587 11C20.9795 11 20.487 10.5075 20.487 9.9C20.487 9.29249 20.9795 8.8 21.587 8.8C22.1945 8.8 22.687 9.29249 22.687 9.9Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.587 15C22.1945 15 22.687 14.5075 22.687 13.9C22.687 13.2925 22.1945 12.8 21.587 12.8C20.9795 12.8 20.487 13.2925 20.487 13.9C20.487 14.5075 20.9795 15 21.587 15Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.687 17.9C22.687 18.5075 22.1945 19 21.587 19C20.9795 19 20.487 18.5075 20.487 17.9C20.487 17.2925 20.9795 16.8 21.587 16.8C22.1945 16.8 22.687 17.2925 22.687 17.9Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 7.4C3.70751 7.4 4.2 6.90751 4.2 6.3C4.2 5.69248 3.70751 5.2 3.1 5.2C2.49249 5.2 2 5.69248 2 6.3C2 6.90751 2.49249 7.4 3.1 7.4Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 11.4C3.70751 11.4 4.2 10.9075 4.2 10.3C4.2 9.69248 3.70751 9.2 3.1 9.2C2.49249 9.2 2 9.69248 2 10.3C2 10.9075 2.49249 11.4 3.1 11.4Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 15.4C3.70751 15.4 4.2 14.9075 4.2 14.3C4.2 13.6925 3.70751 13.2 3.1 13.2C2.49249 13.2 2 13.6925 2 14.3C2 14.9075 2.49249 15.4 3.1 15.4Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3917 22.1C17.3917 22.7075 17.8842 23.2 18.4917 23.2C19.0992 23.2 19.5917 22.7075 19.5917 22.1C19.5917 21.4925 19.0992 21 18.4917 21C17.8842 21 17.3917 21.4925 17.3917 22.1Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3917 22.1C13.3917 22.7075 13.8842 23.2 14.4917 23.2C15.0992 23.2 15.5917 22.7075 15.5917 22.1C15.5917 21.4925 15.0992 21 14.4917 21C13.8842 21 13.3917 21.4925 13.3917 22.1Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4917 23.2C9.88417 23.2 9.39169 22.7075 9.39169 22.1C9.39169 21.4925 9.88417 21 10.4917 21C11.0992 21 11.5917 21.4925 11.5917 22.1C11.5917 22.7075 11.0992 23.2 10.4917 23.2Z",
    fill: "currentColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39169 22.1C5.39169 22.7075 5.88417 23.2 6.49169 23.2C7.0992 23.2 7.59169 22.7075 7.59169 22.1C7.59169 21.4925 7.0992 21 6.49169 21C5.88417 21 5.39169 21.4925 5.39169 22.1Z",
    fill: "currentColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 19.4C3.70751 19.4 4.2 18.9075 4.2 18.3C4.2 17.6925 3.70751 17.2 3.1 17.2C2.49249 17.2 2 17.6925 2 18.3C2 18.9075 2.49249 19.4 3.1 19.4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArtboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArtboard.02480d17f7be07756ed89b40a2519024.svg";